export default __webpack_public_path__ + "static/media/tick-small.8b134e99.svg";